// @ts-check

import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import TableContainer from '@material-ui/core/TableContainer'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableBody from '@material-ui/core/TableBody'
import Paper from '@material-ui/core/Paper'
import Tooltip from '@material-ui/core/Tooltip';
import Accordion from '../../custom/Accordion';
import AccordionSummary from '../../custom/AccordionSummary';
import AccordionDetails from '../../custom/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import clsx from 'clsx';
import useFormStyles from '../../common/FormStyle';
import CostUnitTypeRow from './helpers/CostUnitTypeRow';

function Construction() {
  const formStyles = useFormStyles();
  const buildingInfoState = useSelector(state => state.globalFormData.buildingInfo);
  const units = buildingInfoState.units;
  const currency = useSelector(state => state.globalFormData.costs.currency);

  const [expanded, setExpanded] = useState(false);
  const handleExpanded = () => {
    setExpanded(!expanded);
  };
  return (
    <Accordion expanded={expanded} onChange={handleExpanded}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon fontSize="small" />}
        aria-controls="plotInfo-content"
        id="plotInfo-header"
        IconButtonProps={{
          className: formStyles.expandButton
        }}
      >
        <Typography className={clsx(formStyles.accordionSubheader, formStyles.bold)}>Construction</Typography>
      </AccordionSummary>

      <AccordionDetails>
        <Box className={formStyles.w100}>

          <Box marginY={2}>
            <TableContainer className={formStyles.unitsTableContainer} component={Paper}>
              <Table size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell className={[formStyles.unitsTableCell, formStyles.colorColumn].join(" ")}></TableCell>
                    <TableCell className={[formStyles.unitsTableCell, formStyles.unitTypeNameColumn].join(" ")} >Unit type</TableCell>
                    <Tooltip title="Cost per m²">
                      <TableCell className={[formStyles.unitsTableCell, formStyles.unitCostColumn].join(" ")}>{`Cost (${currency}/${units}²)`}</TableCell>
                    </Tooltip>
                    <Tooltip title="Revenue per m²">
                      <TableCell className={[formStyles.unitsTableCell, formStyles.unitRevenueColumn].join(" ")}>{`Revenue (${currency}/${units}²)`}</TableCell>
                    </Tooltip>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {buildingInfoState.unit_types.map((unitType, index) => (
                    <CostUnitTypeRow unitType={unitType} index={index} key={index} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export default Construction